<div class="row" [class.ion-activatable]="(route && route.length || customAction)" (click)="goTo()">

  <div class="icon" [class.no-icon]="!hasIcon">
    @if(hasIcon) {
      @if(custom) {
        <ion-icon [src]="iconSrc()"></ion-icon>
      } @else {
        <ion-icon [color]="color" [name]="icon"></ion-icon>
      }
    }
  </div>

  <div class="content" [class.noborder]="!border()">
    <p class="label" [style.color]="'var(--ion-color-'+color+')'">{{label()}}</p>
    <div class="chevron">
      @if(arrow) {
        <ion-icon name="chevron-forward"></ion-icon>
      }
    </div>
  </div>
  <ion-ripple-effect color="secondary"></ion-ripple-effect>
</div>